/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsClearingV1MoneyMarketInternalStatsState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_CLEARING_V1_MONEY_MARKET_INTERNAL_STATS_STATE_ENTITY_NAME = 'ixc.assets.clearing.v1.MoneyMarketInternalStats';
export const ixcAssetsClearingV1MoneyMarketInternalStatsStateEntity = new schema.Entity<IxcAssetsClearingV1MoneyMarketInternalStatsState>(IXC_ASSETS_CLEARING_V1_MONEY_MARKET_INTERNAL_STATS_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsClearingV1MoneyMarketInternalStatsState) => `${entity.assetId}-${entity.date}-${entity.dataHash}` });

